import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UnlinkProfessionalUseCaseInterface } from 'domain/usecases';

export class RemoteUnlinkProfessional
  implements UnlinkProfessionalUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<UnlinkProfessionalUseCaseInterface.Result>,
  ) {}

  async execute(
    params: UnlinkProfessionalUseCaseInterface.Params,
  ): Promise<UnlinkProfessionalUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: `${this.url}/${params.id}`,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
